import React, { useState, useRef, useEffect } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { getUsuario } from '../../../../util/Configuracoes'
import { Alterar, AlterarComPermissao, Excluir, Visualizar, BtnCorpoClinico, BloquearSocio, Btn } from '../../../../components/Acoes'
import { ACOES } from '../../../../util/Enums'
import { excluir, get, postComAcao, putComAcao, salvar } from '../../../../util/AcessoApi'
import { mostrarToast } from '../../../../components/Toasts'
import { mensagens, useWindowSize } from '../../../../util/Utilitarios'
import Yup from '../../../../util/Validacoes'
import { ModalCadastro, ModalDuasOpcoes } from '../../../../components/Modais'
import { Formik } from 'formik'
import { Form } from 'react-bootstrap'
import { BotaoPadrao } from '../../../../components/Botoes'
import { InputSocioCorpoClinico } from '../../../../components/InputsAutoCompleteV2'
import ModalBloqueioSocio from '../../cirurgiao/pages/ModalBloqueioSocio'
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown'
const modulo = 76
const ConsultaEstabelecimentoSaude = (props) => {
    const [data, setData] = useState([])
    const [modalCorpoClinico, setModalCorpoClinico] = useState(false)
    const [itemCorpoClinico, setItemCorpoClinico] = useState({})
    const target = useRef(null)
    const { width } = useWindowSize()
    const [estabelecimentoSaudeSetado, setEstabelecimentoSaudeSetado] = useState(null)
    const [modalBloqueioSocio, setModalBloqueioSocio] = useState(false)


    const columns = React.useMemo(
        () => [
            {
                id: 'consulta-estabelecimento-saude',
                columns: [
                    {
                        Header: 'Código',
                        accessor: 'id',
                        ordenamento: {
                            tipo: 'numero',
                            modo: 'desc',
                            ativo: true
                        }
                    }, {
                        Header: 'Identificação',
                        accessor: 'codigo',
                        ordenamento: { tipo: 'numero', }
                    }, {
                        Header: 'Razão Social',
                        accessor: 'razao_social',
                        visivel: false,
                        ordenamento: { tipo: 'texto' }
                    }, {
                        Header: 'Nome Fantasia',
                        accessor: 'nome_fantasia',
                        ordenamento: { tipo: 'texto' }
                    }, {
                        Header: 'CNPJ',
                        accessor: 'cnpj',
                        ordenamento: { tipo: 'texto' }
                    }, {
                        Header: 'CNES',
                        accessor: 'cnes',
                        ordenamento: { tipo: 'texto' }
                    }, {
                        Header: 'Tipo',
                        accessor: 'tipo_estabelecimento_descricao',
                        ordenamento: { tipo: 'texto' },
                        filtro: {
                            tipo: 'tipo_estabelecimento',
                            idColuna: 'tipo_estabelecimento_id'
                        }
                    }, {
                        Header: 'Cidade',
                        accessor: 'nome_municipio',
                        visivel: false,
                        ordenamento: { tipo: 'texto' },
                        filtro: {
                            tipo: 'municipio',
                            idColuna: 'municipio_codigo_ibge'
                        }
                    }, {
                        Header: 'Bairro',
                        accessor: 'bairro',
                        filtro: {
                            tipo: 'pesquisa-geral',
                            idColuna: 'bairro',
                        }
                    }, {
                        Header: 'Urgência?',
                        accessor: 'urgencia',
                        visivel: false,
                        ordenamento: { tipo: 'texto' },
                        filtro: {
                            tipo: 'input_sim_nao',
                            idColuna: 'estabelecimento_saude_urgencia',
                            name: `input_sim_nao_${Math.floor(Math.random() * 1000)}`
                        }
                    }, {
                        Header: 'Ativo?',
                        accessor: 'ativo',
                        visivel: true,
                        ordenamento: { tipo: 'texto' },
                        filtro: {
                            tipo: 'input_sim_nao',
                            idColuna: 'ativo',
                            name: `input_sim_nao_${Math.floor(Math.random() * 1000)}`,
                            valor: { value: 'true', label: 'Sim' },
                            valor_inicial: { value: 'true', label: 'Sim' }
                        }
                    }, {
                        Header: 'Data Atualização',
                        accessor: 'data_atualizacao',
                        ordenamento: {
                            tipo: 'data'
                        },
                    }, {
                        Header: 'Data Registro',
                        accessor: 'data_registro',
                        ordenamento: { tipo: 'data' }
                    },
                ],
            },
        ],
        []
    )

    const exclusao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: props.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/faturamento/guia', propsAcao.row.id,
                    () => {
                        // getApi(setData, '/faturamento/guia')
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    }, propsAcao.row.descricao_auditoria)
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const OutrasAcoes = ({ propsAcao, ...props }) => {
        return (
            <Dropdown >
                <DropdownTrigger>
                    <Btn icone='icon-ellipsi' texto="Mais Ações" />
                </DropdownTrigger>
                <DropdownContent>
                    <div className="card-acoes-dropdown">
                        <div className="ajusta-dropdown-consulta-guia">
                            {[<Excluir to={'/administracao/estabelecimentoSaude/'} action={() => exclusao(propsAcao)} />,
                            <BtnCorpoClinico action={() => {
                                setItemCorpoClinico(propsAcao.row);
                                setModalCorpoClinico(true)
                            }} />,
                            <BloquearSocio icone={'icon-Lock-User'} texto={'Bloquear Sócio'} action={() => {
                                console.log('propsAcao: ', propsAcao);


                                setEstabelecimentoSaudeSetado({ value: propsAcao.id, label: propsAcao.row?.descricao_auditoria }); setModalBloqueioSocio(true)
                            }} />
                            ]}
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }

    const acoesObj = [ // AÇÕES PARA TELA MENOR 1920
        (propsAcao) => <Visualizar to={'/administracao/estabelecimentoSaude/visualizacao/' + propsAcao.row.id} />,
        (propsAcao) => <Alterar to={'/administracao/estabelecimentoSaude/alteracao/' + propsAcao.row.id} modulo={modulo} target={'_self'} />,
        (propsAcao) => <OutrasAcoes propsAcao={propsAcao} />,

    ]
    useEffect(() => {
        if (!modalBloqueioSocio) {
            setEstabelecimentoSaudeSetado(null)
        }

    }, [modalBloqueioSocio])

    return (
        <div>
            <DataGridAlternativa target={target} data={data} acoes={true} acoesObj={acoesObj} columns={columns} setData={setData} caminhoBase='/administracao/estabelecimentoSaude'
                tituloLista={'Lista Estabelecimento Saúde'} caminhoConsultaFiltros='/administracao/estabelecimentoSaudePaginacao'
                urlCadastro='/administracao/estabelecimentoSaude/cadastro' modulo={props.modulo} titulo={'Consulta Estabelecimento Saúde'} icone={'icon-Hospital-2'}
                atualizarEstabelecimento={() => props.obterWebService(JSON.stringify({ "integrationType": "estabelecimento_saude", "key": "10", "usuarioId": getUsuario().id, "moduloId": 9, "acaoId": 30 }))}
            />
            <ModalBloqueioSocio estabelecimentoSaude={estabelecimentoSaudeSetado || []} abrirModal={modalBloqueioSocio} setAbrirModal={setModalBloqueioSocio} />

            <CorpoClinico target={target} titulo={'Corpo Clínico'} abrirModal={modalCorpoClinico} setAbrirModal={setModalCorpoClinico} item={itemCorpoClinico} />

        </div>
    )
}



const CorpoClinico = ({ target, ...props }) => {

    const [salvando, setSalvando] = useState(false)
    const [itemAtual, setItemAtual] = useState(null)
    const [valoresIniciais, setValoresIniciais] = useState(null)
    const refCorpoClinico = useRef(null)
    const [validacao] = useState(Yup.object({
        socio: Yup.object().nullable().required()
    }))

    useEffect(() => {
        const item = props.item
        get('/administracao/obterestabelecimentocorpoclinico', { id: item.id }, null, null).then(val => {
            if (val && val.length) {
                setValoresIniciais(val[0])
            }
            else {
                setValoresIniciais({ socio: '' })
            }
        })

        setItemAtual(item);
    }, [props.item])

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        values.id_estabelecimento = props.item.id
        values.id = props.item.id

        putComAcao(ACOES.CORPO_CLINICO, 9, values, '/administracao/estabelecimentocorpoclinico',
            (res) => {
                mostrarToast('sucesso', mensagens.sucesso)
                target.current.atualizar();
                props.setAbrirModal(false)
                setSalvando(false)
            },
            (erro) => {
                setSalvando(false)
                // mostrarToast('error', mensagens.erro)
            })
    }

    return (
        <>
            <ModalCadastro titulo={props.titulo} show={props.abrirModal} setShowModal={props.setAbrirModal} >
                <Formik
                    initialValues={valoresIniciais}
                    validationSchema={Yup.object({
                        socio: Yup.object().nullable()
                    })}
                    enableReinitialize={true}
                    onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
                    {propsFormik => (

                        <Form>
                            <div className='modal-body-cadastro'>
                                <div class="separator mt-20 mb-20"> </div>
                                <DetalhesEstabSaude detalhesEstabSaude={props.item} />

                                <div className={'form-group col-12 p-0'} style={{ height: "auto", maxHeight: "none", overflow: "visible" }}>

                                    <div ref={refCorpoClinico}>
                                        <InputSocioCorpoClinico label="Sócio" name="socio" placeholder="Sócio" propsFormik={propsFormik} tamanho='col-lg-12' multiplo
                                            autoFocus />
                                    </div>

                                </div>
                            </div>
                            <div className='separator mt-40 mb-2'></div>
                            <div className='direita container-botoes mb-3 group-salvar-novo'>
                                <BotaoPadrao texto='Salvar' disabled={salvando} click={propsFormik.handleSubmit} idTooltip={"salvar"} />
                            </div>
                        </Form>

                    )}
                </Formik>
            </ModalCadastro>
        </>
    );
}


const DetalhesEstabSaude = ({ detalhesEstabSaude, ...props }) => {

    let dados = {}

    dados.dados_lancamento = [

        { titulo: 'Código', descricao: detalhesEstabSaude?.id },
        { titulo: 'Identificação', descricao: detalhesEstabSaude?.codigo },
        { titulo: 'CNPJ', descricao: detalhesEstabSaude?.cnpj },
        { titulo: 'Nome Fantasia', descricao: detalhesEstabSaude?.nome_fantasia },
    ]


    return (
        <div className='col-12 '>
            <div className='detalhes '>
                <div className='item-detalhes display-flex col-12 row'>
                    {dados?.dados_lancamento ?

                        dados?.dados_lancamento.map((item, idx) => {
                            return (
                                <>
                                    {/* {idx === 0 ? <></> : <hr />} */}

                                    <div className={item.titulo.includes('Cliente') ? 'col-12' : 'col-6'}>
                                        <h6><b>{item.titulo}</b></h6>
                                        {item?.titulo?.includes('Valor R$') || item.titulo.includes('Data') ?
                                            <h6 >
                                                <b className='valor-indicador-certo'>{item.descricao}</b>
                                            </h6>
                                            :
                                            <h6 >{item.descricao}</h6>}
                                        {item.html}
                                    </div>

                                </>
                            )
                        })
                        : <></>
                    }
                </div>

            </div>
            <div class="separator mt-20 mb-20"></div>
        </div>
    )

}

export default ConsultaEstabelecimentoSaude